import { DiagnosticType } from '@/services/models/enums'

import { VariableTypeSelectEntry } from '../../services/db/schema'

function addTypesToVariables<T extends { typeId: string | null }>(
  variables: T[],
  variableTypes: Array<VariableTypeSelectEntry>,
) {
  const typesMap = new Map(variableTypes.map((t) => [t.id, t]))

  return variables.map((variable) => {
    if (!variable.typeId) {
      return {
        ...variable,
        type: {
          id: null,
          name: 'Unknown',
          color: '#FFFFFF',
          diagnosticType: DiagnosticType.None,
          upstreamEffectsDisabled: false,
          isPublishable: false,
          useWorstStateAsReference: false,
        },
      }
    }
    const type = typesMap.get(variable.typeId)
    if (!type) {
      throw new Error(`Variable type not found for typeId: ${variable.typeId}`)
    }
    return { ...variable, type }
  })
}

export default addTypesToVariables
